import { trackError, trackCriticalError } from '../services/errorTrackingService';

let hasRegistered = false;
let lastErrorTime = 0;
const ERROR_THROTTLE_MS = 5000;

function shouldLogError(): boolean {
  const now = Date.now();
  if (now - lastErrorTime < ERROR_THROTTLE_MS) {
    return false;
  }
  lastErrorTime = now;
  return true;
}

export function initGlobalErrorHandler(): void {
  if (hasRegistered || typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    if (!shouldLogError()) return;

    const error = event.error || new Error(event.message);

    trackError(error, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    }).catch(console.error);
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!shouldLogError()) return;

    const reason = event.reason;
    const error = reason instanceof Error ? reason : new Error(String(reason));

    trackError(error, {
      type: 'unhandledRejection',
    }).catch(console.error);
  });

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    try {
      const response = await originalFetch.apply(this, args);

      if (!response.ok && response.status >= 500) {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.toString() || 'unknown';

        trackCriticalError(`Network error: ${response.status} ${response.statusText}`, {
          url,
          status: response.status,
          statusText: response.statusText,
        }).catch(console.error);
      }

      return response;
    } catch (error) {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.toString() || 'unknown';

      trackCriticalError(`Fetch failed: ${error instanceof Error ? error.message : String(error)}`, {
        url,
        error: error instanceof Error ? error.message : String(error),
      }).catch(console.error);

      throw error;
    }
  };

  hasRegistered = true;
  console.log('[Error Handler] Global error handler initialized');
}
